module.exports = __webpack_public_path__ + "static/Sakshi_Chopra.cd44957b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Sakshi_Chopra.jpg
// module id = 925
// module chunks = 146520050992020